/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = INPROGRESS
 *
 * 1 = CONFIRMED
 *
 * 2 = CANCELLED
 *
 * 3 = INVOICED
 *
 * 4 = CLOSED
 */
export enum SalesOrderStatus {
  INPROGRESS = 0,
  CONFIRMED = 1,
  CANCELLED = 2,
  INVOICED = 3,
  CLOSED = 4,
}
